const mobileFixedButton = (el) => {
  ScrollTrigger.create({
    trigger: "body",
    start: "+=300",
    end: "-=310",
    onEnter: () => {
      el.classList.add("is-active");
    },
    onLeaveBack: () => {
      el.classList.remove("is-active");
    },
  });
  ScrollTrigger.create({
    trigger: "#form",
    start: "top bottom",
    end: "top bottom",
    onEnter: () => {
      el.classList.remove("is-active");
    },
    onLeaveBack: () => {
      el.classList.add("is-active");
    },
  });
};
